module.exports = __webpack_public_path__ + "img/progress_074.f572ce3b.png";